import { map, mapValues, find, pickBy } from 'lodash';
import uniqid from 'app/libs/uniqid.js';
import store from 'app/store/index';
import { getResources } from 'app/store/selectors/getResources.js';
export function getPostBoardLinksModels(state = store.getState(), paginatedList) {
    const postBoardLinks = getResources(state, `postBoardLinks.paginatedLists.${paginatedList}`, undefined, [
        'assetInst.assetFlagsInst.flagInst',
        'assetInst.assetMediaGroupsInst.mediaGroupInst.mediasInst',
        'notesInst',
        'episodeInst',
    ]);
    return mapValues(postBoardLinks, (postBoardLink) => {
        const postBoardNotes = postBoardLink.notesInst;
        const stepProjects = pickBy(getResources(state, 'stepProjects', { project: postBoardLink.assetInst.project }, ['stepInst']), (stepProject) => stepProject.stepInst.assetType === 'mo');
        const notesInst = {};
        const stepsWithGeneral = [
            {
                name: 'General',
                id: null,
            },
            ...map(stepProjects, (stepProject) => stepProject.stepInst),
        ];
        stepsWithGeneral.forEach((step) => {
            const existingNote = find(postBoardNotes, (note) => note.step === step.id);
            if (existingNote) {
                notesInst[existingNote.id] = existingNote;
            }
            else {
                notesInst[`LOCAL_${uniqid()}`] = {
                    step: step.id,
                    link: postBoardLink.id,
                    id: null,
                    text: '',
                };
            }
        });
        return Object.assign(Object.assign({}, postBoardLink), { notesInst, rowId: postBoardLink.id });
    });
}
